import { useNavigate, useLocation } from 'react-router-dom';
import Button from '@/shared/components/Button';
import { APP_ROUTES } from '@/app/routePaths';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(APP_ROUTES.DASHBOARD, { replace: true });
  };

  return (
    <div className="px-page-x pt-8 pb-10 flex flex-col items-center justify-center flex-1 min-h-[60vh]">
      <div className="w-full max-w-md text-center">
        <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-muted text-primary text-xs font-bold tracking-widest mb-4">
          404
        </span>
        <h1 className="text-2xl font-semibold text-foreground tracking-tight leading-8 mb-3">
          Page not found
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          We couldn&apos;t find{' '}
          <strong className="text-foreground font-medium">{location.pathname}</strong>.
        </p>
        <p className="text-sm text-muted-foreground leading-relaxed mt-1">
          The page may have moved, the URL may be incorrect, or it doesn&apos;t exist.
        </p>

        <div className="flex gap-3 justify-center mt-6 flex-wrap">
          <Button variant="ghost" onClick={handleGoBack}>
            Go back
          </Button>
          <Button variant="primary" onClick={() => navigate(APP_ROUTES.DASHBOARD, { replace: true })}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
